import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MonedasConstant } from 'constants/index'

const ImportePagoFormGroup = ({
  vMoneda,
  vMonedaPago,
  vTipoCambio,
  vImporteBase,
  iValue,
  setFieldValue
}) => {
  React.useEffect(() => {
    if (vMoneda !== vMonedaPago) {
      if (vMoneda === MonedasConstant.SOLES && vMonedaPago === MonedasConstant.DOLARES) {
        const nuevoMonto = +(parseFloat(vImporteBase) / parseFloat(vTipoCambio)).toFixed(2)
        setFieldValue('importePago', nuevoMonto)
      } else if (vMoneda === MonedasConstant.DOLARES && vMonedaPago === MonedasConstant.SOLES) {
        const nuevoMonto = +(parseFloat(vImporteBase) * parseFloat(vTipoCambio)).toFixed(2)
        setFieldValue('importePago', nuevoMonto)
      }
    } else {
      setFieldValue('importePago', vImporteBase)
    }
  }, [vMoneda, vMonedaPago, vTipoCambio, vImporteBase, setFieldValue])

  return (
    <Form.Group>
      <Form.Label
        text={`IMPORTE (${MonedasConstant.__dictionary[vMonedaPago].signo})`}
        htmlFor='number-importePago'
        md={4}
      />
      <Col md={8}>
        <Field name='importePago'>
          {({ field }) => <Form.InputNumber {...field} id='number-importePago' value={iValue} />}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImportePagoFormGroup)
